import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import {
    AdminFeatureView,
    CatalogContextView,
    SettingPageView,
    DefaultSetupView,
    ThemePageView,
    ThemeConfigView,
    ElementPageView,
    LayoutPageView,
    HeaderPageView,
    HtmlPageView,
    SessionPageView,
    TemplateConfigView,
    ImageConfigView,
    RegionConfigView,
    HtmlConfigView,
    LabelConfigView,
    SpeakerPageView,
    TabsPageView,
    TabConfigView,
    DataPageView,
    GeneralPageView,
    HighlightedPageView,
    FilterPageView,
    FilterConfigView,
    FilterConfigSectionView,
    FilterCustomizeDisplaySectionView,
    GroupingCustomizeDisplaySectionView,
    AdditionalSettingPageView,
    LoginPageView,
    MySessionPageView,
    SessionConfigView,
    MysessionConfigView,
    LoginConfigView,
    LoginConfigSectionView,
    SessionExpiredConfigView,
    ConfigAfterLoginSectionView,
    EditFilterLabelView,
    ButtonConfigView,
    CalendarTemplateView,
    CalendarConfigView,
    MyscheduleConfigView,
    AssetConfigView,
    AssetDisplayConfigView,
    SaveFilterConfigView,
    RulesValidationView,
    SessionResourcesPageView,
    MyresourcesConfigView,
    ResourceAssetConfigView,
    ResourceAssetDisplayConfigView,
    RecommendationWidgetPageView,
    WidgetConfigPageView,
    WidgetTextConfigPageView,
    RecommendationsPageView

} from ".";
import { DefaultPopupView } from "./drawers/popup-drawer/popup-section.view";
import { DefaultDrawerView } from "./drawers/config-drawer/drawer-section.view";
import { cclBuilderDrawerRoutes } from "certain-common-library";
import { CanDeactivateGuard } from "./can-deactivate";
import { CatalogUuidResolver } from "../../modules/shared/resolvers/cataloguuid.resolver";
import { SettingView, TimezoneSettingView } from "./catalog-context";

const featureRoutes: Routes = [
    {
        path: "admin/:catalogUuid",
        resolve: {
            catalog: CatalogUuidResolver
        },
        component: AdminFeatureView,
        children: [
            {
                path: "catalog",
                component: CatalogContextView,
                children: [
                    {
                        path: "setting",
                        component: SettingPageView,
                        children: [
                            {
                                path: "theme",
                                component: ThemePageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "page-element",
                                component: ElementPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            { path: "**", redirectTo: "page-element" }
                        ]
                    },
                    {
                        path: "layout",
                        component: LayoutPageView,
                        children: [
                            {
                                path: "header",
                                component: HeaderPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "html-top",
                                component: HtmlPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "html-bottom",
                                component: HtmlPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "footer",
                                component: HeaderPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "highlighted-session",
                                component: SessionPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "promoted-session",
                                component: SessionPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "general-session",
                                component: SessionPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "speaker",
                                component: SpeakerPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "tabs",
                                component: TabsPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "filter",
                                component: FilterPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "login",
                                component: LoginPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "mysession",
                                component: MySessionPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "sessionresources",
                                component: SessionResourcesPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            { path: "**", redirectTo: "header" }
                        ]
                    },
                    {
                        path: "recommendations-widget",
                        component: RecommendationsPageView,
                        children: [
                            {
                                path: "sessionrecommendationwidget",
                                component: RecommendationWidgetPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            { path: "**", redirectTo: "sessionrecommendationwidget" }
                        ]
                    },
                    {
                        path: 'add-setting',
                        component: SettingView,
                        children: [
                            {
                                path: "additional-setting",
                                component: AdditionalSettingPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: 'edit-label',
                                component: EditFilterLabelView

                            },
                            {
                                path: 'button-config',
                                component: ButtonConfigView
                            },
                            {
                                path: "add-to-calendar-config",
                                component: CalendarTemplateView
                            },
                            {
                                path: 'rules-validation-config',
                                component: RulesValidationView

                            },
                            { path: "**", redirectTo: "additional-setting" }
                        ]
                    },
                    {
                        path: "data",
                        component: DataPageView,
                        children: [
                            {
                                path: "highlighted",
                                component: HighlightedPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "promoted",
                                component: HighlightedPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "general",
                                component: GeneralPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            { path: "**", redirectTo: "highlighted" }
                        ]
                    },
                    { path: "**", redirectTo: "setting" }
                ]
            },
            { path: "**", redirectTo: "catalog" }
        ]
    },
    {
        outlet: "drawer",
        path: "config-drawer",
        component: DefaultDrawerView,
        children: [
            {
                path: "tab-config",
                component: TabConfigView
            },
            {
                path: "filter",
                component: FilterConfigView,
                children: [
                    {
                        path: "config",
                        component: FilterConfigSectionView
                    },
                    {
                        path: "timezone-setting",
                        component: TimezoneSettingView
                    },
                    {
                        path: "customize-display",
                        component: FilterCustomizeDisplaySectionView
                    },
                    {
                        path: "save-filter",
                        component: SaveFilterConfigView
                    },
                    { path: "**", redirectTo: "config" }
                ]
            },
            {
                path: "theme-config",
                component: ThemeConfigView
            },
            {
                path: "session",
                children: [
                    {
                        path: "template-config",
                        component: TemplateConfigView
                    },
                    {
                        path: "image-config",
                        component: ImageConfigView
                    },
                    {
                        path: "region-config",
                        component: RegionConfigView
                    },
                    {
                        path: "html-config",
                        component: HtmlConfigView
                    },
                    {
                        path: "html-private-config",
                        component: HtmlConfigView
                    },
                    {
                        path: "label-config",
                        component: LabelConfigView
                    },
                    {
                        path: "session-config",
                        component: SessionConfigView
                    },
                    {
                        path: "mysession-config",
                        component: MysessionConfigView
                    },
                    {
                        path: "myschedule-config",
                        component: MyscheduleConfigView
                    },
                    {
                        path: "calendar-config",
                        component: CalendarConfigView
                    },
                    {
                        path: "asset-config",
                        component: AssetConfigView
                    },
                    {
                        path: "asset-display-config",
                        component: AssetDisplayConfigView
                    },
                    {
                        path: "myresources-config",
                        component: MyresourcesConfigView
                    },
                    {
                        path: "resource-asset-config",
                        component: ResourceAssetConfigView
                    },
                    {
                        path: "resource-asset-display-config",
                        component: ResourceAssetDisplayConfigView
                    },
                    {
                        path: "widget-config-page",
                        component: WidgetConfigPageView
                    },
                    {
                        path: "widget-text-config-page",
                        component: WidgetTextConfigPageView
                    }
                ]
            },
            {
                path: "speaker",
                children: [
                    {
                        path: "template-config",
                        component: TemplateConfigView
                    },
                    {
                        path: "image-config",
                        component: ImageConfigView
                    },
                    {
                        path: "region-config",
                        component: RegionConfigView
                    },
                    {
                        path: "html-config",
                        component: HtmlConfigView
                    },
                    {
                        path: "label-config",
                        component: LabelConfigView
                    }
                ]
            },
            {
                path: "grouping",
                component: FilterConfigView,
                children: [
                    {
                        path: "customize-display",
                        component: GroupingCustomizeDisplaySectionView
                    },
                    { path: "**", redirectTo: "customize-display" }
                ]
            },
            {
                path: "login",
                component: LoginConfigView,
                children: [
                    {
                        path: "config",
                        component: LoginConfigSectionView
                    },
                    {
                        path: "after-login",
                        component: ConfigAfterLoginSectionView
                    },
                    { path: "**", redirectTo: "config" }
                ]
            },
            {
                path: "session-expired",
                component: LoginConfigView,
                children: [
                    {
                        path: "config",
                        component: SessionExpiredConfigView
                    },
                    { path: "**", redirectTo: "config" }
                ]
            }
        ]
    },
    {
        outlet: "popup",
        path: "popup",
        component: DefaultPopupView,
        children: [
            {
                path: "default-setup",
                component: DefaultSetupView
            }
        ]
    },
    cclBuilderDrawerRoutes
];
@NgModule({
    imports: [RouterModule.forChild(featureRoutes), BrowserModule, HttpClientModule],
    exports: [RouterModule],
    providers: [CatalogUuidResolver]
})
export class AdminFeatureRoutingModule {
    title = "Admin";
}
